// components/PrinterActions.tsx
import React from "react";

interface PrinterActionsProps {
  onWhatsAppClick: () => void;
  onPrintClick: () => void;
  isPrinting?: boolean;
}

const PrinterActions: React.FC<PrinterActionsProps> = ({ 
  onWhatsAppClick, 
  onPrintClick, 
  isPrinting = false 
}) => {
  return (
    <div className="flex justify-center space-x-4 mt-6">
      <button
        onClick={onWhatsAppClick}
        className="bg-green-500 hover:bg-green-600 text-white px-6 py-2 rounded-lg font-medium transition-colors"
      >
        WhatsApp
      </button>
      <button
        onClick={onPrintClick}
        disabled={isPrinting}
        className={`bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-lg font-medium transition-colors ${
          isPrinting ? 'opacity-50 cursor-not-allowed' : ''
        }`}
      >
        {isPrinting ? 'Printing...' : 'Print'}
      </button>
    </div>
  );
};

export default PrinterActions;